const login = {
  mode: "en",
  title: "Log in",
  description: "Log in to your TradDocs account. Connect with skilled developers and explore a world of possibilities. Sign in now for top-notch developer services.",
  subtitle: "Global Developer Matching Platform",
  google: "Continue with Google",
  or: "OR",
  username: "Email address",
  password: "Password",
  login: "Log in",
  loading: "Loading...",
  rememberMe: "Remember me",
  forgotPassword: "Forgot Password?",
  notAMember: "Not a member yet?",
  signUp: "Join now",
  error: {
    unknown: "Something went wrong...",
    unregistered: "Wrong email or password",
    wrong: "Wrong email or password",
    invalidFormat: "Invalid email format",
  },
};

export default login;
